import axios from '.';

export default {
  fetchRevertedTransactions,
  fetchRevertedUserWithdrawal
};

async function fetchRevertedTransactions() {
  const response = await axios.get('/api/users/reverted-transactions');
  return response.data;
}

async function fetchRevertedUserWithdrawal() {
  const response = await axios.get('/api/users/reverted-user-withdrawal');
  return response.data;
}
